import { concatStyleSets, IChoiceGroupOptionStyles, IChoiceGroupStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { Sizes } from '../../themes/styles';

export const choiceGroupStylesDefault = (theme: IH2OTheme): Partial<IChoiceGroupStyles> => ({
  label: {
    color: theme.semanticColors?.inputReadOnlyText,
  },
});

const paddingTop = 16;
const paddingLeft = 24;
const gapForDot = 3;
const radioLocation = {
  '::before': {
    top: paddingTop,
    left: paddingLeft,
  },
  '::after': {
    top: paddingTop + gapForDot,
    left: paddingLeft + gapForDot,
  },
  ':hover::after': {
    top: paddingTop + gapForDot,
    left: paddingLeft + gapForDot,
  },
};
export const choiceGroupStylesBox = (theme: IH2OTheme): Partial<IChoiceGroupStyles> => ({
  root: {
    '.ms-ChoiceField-field': {
      padding: `${paddingTop}px ${paddingLeft}px`,
      borderRadius: Sizes.borderRadius,
      border: `1px solid ${theme.semanticColors?.inputBorder}`,
      ...radioLocation,
    },
    '.ms-ChoiceField-field.is-checked': {
      border: `1px solid ${theme.palette?.primary500}`,
      backgroundColor: theme.palette?.primary100,
    },
    '.ms-ChoiceField-field.is-disabled': {
      ...radioLocation,
    },
  },
});

export const choiceGroupStylesHorizontalBox = (theme: IH2OTheme): Partial<IChoiceGroupStyles> =>
  concatStyleSets(choiceGroupStylesBox(theme), {
    flexContainer: {
      display: 'flex',
      gap: Sizes.padding,
      '.ms-ChoiceField': {
        flex: 1,
      },
      '.ms-ChoiceField-wrapper': {
        flex: 1,
      },
      '.ms-ChoiceField-field': { width: '100%' },
    },
  });

export const choiceGroupOptionStylesDefault = (theme: IH2OTheme): Partial<IChoiceGroupOptionStyles> => ({
  root: {},
  field: {
    minHeight: 16,
    lineHeight: 16,
    '::before': {
      width: 16,
      height: 16,
    },
    '::after': {
      left: 3,
      top: 3,
    },
    ':hover::after': {
      left: 3,
      top: 3,
    },
    '&.is-checked': {
      '::before': {
        borderColor: theme.semanticColors?.inputReadOnlyText,
      },
      '::after': {
        borderColor: theme.semanticColors?.inputReadOnlyText,
        backgroundColor: theme.semanticColors?.inputReadOnlyText,
      },
    },
    '&.is-disabled': {
      color: theme.semanticColors?.textDisabled,
      '::before': {
        borderColor: theme.semanticColors?.textDisabled,
      },
      '::after': {
        borderColor: theme.semanticColors?.textDisabled,
        backgroundColor: theme.semanticColors?.textDisabled,
      },
    },
  },
});
